import { render, staticRenderFns } from "./checkLowerPrice.vue?vue&type=template&id=3121fc59&scoped=true"
import script from "./checkLowerPrice.vue?vue&type=script&lang=js"
export * from "./checkLowerPrice.vue?vue&type=script&lang=js"
import style0 from "./checkLowerPrice.vue?vue&type=style&index=0&id=3121fc59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3121fc59",
  null
  
)

export default component.exports